import React from "react";
import { Box, Paper, Modal, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const NewModal = (props) => {
  const handleNew = () => {
    console.log("new account");
    props.handleClose();
  };
  return (
    <div>
      <Modal open={props.open} onClose={props.handleClose}>
        <Box sx={style}>
          <Typography variant="h6" component="h2">
            درخواست اکانت
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            لطفا اطلاعات زیر را پر کنید .
          </Typography>
          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid xs={6}>
              <Button
                fullWidth
                color="success"
                variant="contained"
                onClick={handleNew}
              >
                ارسال
              </Button>
            </Grid>
            <Grid xs={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={props.handleClose}
              >
                بازگشت
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default NewModal;
